module.exports = __webpack_public_path__ + "img/036.61e4f5a0.png";